import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <IndexSection />
        <TopicsSection />
        <CardsSection />
        <AboutSection />
        <FeaturesSection />
        <ContactSection />
        <RankingSection />
        <CommentsSection />
        <MediaSection />
        <FaqSection />
        <CarouselSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}